import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10.838 15.875h4.25a5.5 5.5 0 0 1 5.5 5.5h1.5v-5a7 7 0 0 0-7-7H10.84l.002-1.677A2 2 0 0 0 7.374 6.34l-4.552 4.93a2 2 0 0 0 0 2.712l4.549 4.928a2 2 0 0 0 3.467-1.356v-1.678zm9.75 5.5c0 1 1.5 1 1.5 0h-1.5zm-5.5-7h-5a.75.75 0 0 0-.75.75v2.427a.5.5 0 0 1-.866.339l-4.548-4.927a.5.5 0 0 1 0-.678l4.551-4.928a.5.5 0 0 1 .866.34l-.003 2.426c0 .415.336.751.75.751h5a5.5 5.5 0 0 1 5.5 5.5v.67a6.988 6.988 0 0 0-5.5-2.67z' />
  </svg>
);
